import { InjectionToken } from '@angular/core';
import { User } from '@marmon/shared/types/user';
import { DocumentData, DocumentReference } from 'firebase/firestore';
import { BehaviorSubject } from 'rxjs';

export const USER = new InjectionToken<BehaviorSubject<User | null>>(
	'UserToken',
);

export const USER_REF = new InjectionToken<
	BehaviorSubject<DocumentReference<User, DocumentData> | null>
>('UserRefToken');
